import React from 'react';

// main component for the logged out layout
const LoggedOutLayout = ({ children }) => {
	return (
		<div className='LoggedOutLayout'>
			{children}
		</div>
	);
};

export default LoggedOutLayout;
